<template>
    <div class="main">
        <transition>
            <router-view name="registerSubNavigation"/>
        </transition>
        <transition>
            <router-view/>
        </transition>
    </div>
</template>
<script>

export default {
    name: 'Canvasser',
    mounted() {
        this.$store.dispatch('account/fetchUserData', true);
    },
};
</script>
